import { action } from 'easy-peasy';
import { IActionSetMedicaidPlan } from '../types';

const setMedicaidPlan: IActionSetMedicaidPlan = action((state, payload) => {
  state.medicaidPlan = payload;
});

export default setMedicaidPlan;
